import {Model} from "ords/dist/model/model";

export class AssignmentStatusActivity extends Model {
    getStatusText(status) {

        switch (status) {
            case 0:
                return 'Ingeleverd';
            case 1:
                return 'Goed gekeurd';
            case 2:
                return 'Heropent';
            default:
                return null;
        }
    }

    getOldStatusText() {
        return this.getStatusText(this.properties.old?.status)
    }

    getNewStatusText() {
        return this.getStatusText(this.properties.attributes.status)

    }
}
export const AssignmentStatusActivityModelConfig = {
    name: 'assignmentStatusActivity',
    model: AssignmentStatusActivity,
    relation: [
        {name: 'causer', model_name: 'user', type: 'hasOne'},
    ]
}
